import {useState} from "react";
import {ApiError} from "../services/ApiClient";

type ApiCallback<TArgs extends any[], TResult> = (...args: TArgs) => Promise<TResult>;

export const useApiRequest = <TArgs extends any[], TResult>(
    apiFn: ApiCallback<TArgs, TResult>
) => {
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState<ApiError | undefined>(undefined);
    const [errMsg, setErrMsg] = useState<string | undefined>(undefined);

    const execute = async (...args: TArgs): Promise<TResult | undefined> => {
        setLoading(true);
        setErrMsg(undefined);
        setErr(undefined);
        try {
            const result = await apiFn(...args);
            // Optionally handle result.error in the hook if your API uses that pattern
            if ((result as any).error) {
                setErrMsg((result as any).error.message);
                if (isApiError(result)) {
                    setErr(result as ApiError);
                }
                return result;
            }
            return result;
        } catch (err: any) {
            setErrMsg(err.message || "Something went wrong.");
            return undefined;
        } finally {
            setLoading(false);
        }
    };

    return { execute, loading, err, errMsg, setErrMsg };
};

function isApiError(obj: any): obj is ApiError {
    return obj && typeof obj.message === "string" && typeof obj.code === "string";
}